export default __webpack_public_path__ + "static/media/selfie2.d224ec00.png";